/**
 * What a VITA shade looks like on a screen - approximately.
 *
 * The shade guide is a physical set of ceramic tabs, and no screen reproduces
 * translucent ceramic under clinic light. These are the tabs' average body
 * colours, close enough that a patient sees "tooth-coloured, a little warm"
 * rather than the flat white of an unshaded model, which beside their own
 * teeth looks wrong to them even when the crown is right. The page says so in
 * words; this is an impression, not a colour match.
 *
 * VITA classical (A1-D4) and the 0M bleach shades, which the desktop's shade
 * groups use.
 */
const VITA: Record<string, string> = {
  '0M1': '#f7f2e7',
  '0M2': '#f4eee1',
  '0M3': '#f1e9d8',
  B1: '#f3eadb',
  A1: '#efe3cd',
  B2: '#ecdec2',
  D2: '#e7dac6',
  A2: '#e9d7b8',
  C1: '#e5d9c5',
  C2: '#ddcdb2',
  D4: '#d9c7a7',
  A3: '#e2caa3',
  D3: '#dac9ae',
  B3: '#e0c89f',
  'A3.5': '#dbbf94',
  B4: '#d7bb8e',
  C3: '#d3c0a0',
  A4: '#cfb386',
  C4: '#c5af8d',
};

/** The screen colour for a shade name, or null for an unknown or missing shade. */
export function shadeColour(shade: string | null | undefined): string | null {
  if (!shade) return null;
  const key = shade.trim().toUpperCase().replace(/\s+/g, '');
  return VITA[key] ?? null;
}
